import { useEffect, useRef } from "react";
import { mobileInput, mobilePrimaryBtn } from "../theme";

/**
 * Campo de pesquisa mobile. Mantém o termo digitado em ref síncrona para
 * o clique em Buscar / Enter não usar estado React atrasado.
 */
export default function MobileSearchBar({
  value,
  onChange,
  onSubmit,
  label = "Pesquisar",
  placeholder = "Nome, e-mail, CPF…",
  showSubmitButton = true,
  submitLabel = "Buscar",
  submitDisabled = false,
}) {
  const latestRef = useRef(value ?? "");

  useEffect(() => {
    latestRef.current = value ?? "";
  }, [value]);

  const emitSubmit = (raw) => {
    if (submitDisabled) return;
    const q = raw ?? latestRef.current ?? "";
    latestRef.current = q;
    onSubmit?.(q);
  };

  return (
    <div className="sticky top-0 z-10 border-b border-primary/40 bg-mgs-bg px-4 py-2">
      <label className="block text-sm font-medium text-laranjinha">
        {label}
        <input
          type="search"
          value={value}
          onChange={(e) => {
            latestRef.current = e.target.value;
            onChange(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              emitSubmit(e.target.value);
            }
          }}
          placeholder={placeholder}
          className={`mt-1 ${mobileInput}`}
        />
      </label>
      {showSubmitButton ? (
        <button
          type="button"
          onClick={() => emitSubmit()}
          disabled={submitDisabled}
          className={`mt-2 w-full ${mobilePrimaryBtn}`}
        >
          {submitLabel}
        </button>
      ) : null}
    </div>
  );
}
